import { computed, ComputedRef } from 'vue'

import { ModelAnswerPageStateViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerPageStateViewModel'

export class ModelAnswerPageStatePresenter {
  private viewModel: ModelAnswerPageStateViewModel

  constructor(viewModel: ModelAnswerPageStateViewModel) {
    this.viewModel = viewModel
  }

  get modelAnswerExpandedList(): ComputedRef<{ [judgeId: number]: boolean }> {
    return this.viewModel.modelAnswerExpandedList
  }

  get modelAnswerLoadingList(): ComputedRef<{ [judgeId: number]: boolean }> {
    return this.viewModel.modelAnswerLoadingList
  }

  get modelAnswerIsDiffList(): ComputedRef<{ [judgeId: number]: boolean }> {
    return this.viewModel.modelAnswerIsDiffList
  }

  hasDataInExpandedList(judgeId: number): ComputedRef<boolean> {
    return computed(() => judgeId in this.viewModel.modelAnswerExpandedList.value)
  }

  hasDataInLoadingList(judgeId: number): ComputedRef<boolean> {
    return computed(() => judgeId in this.viewModel.modelAnswerLoadingList.value)
  }

  get pageIndex(): ComputedRef<number> {
    return this.viewModel.pageIndex
  }

  get isFirstOpendPage(): ComputedRef<boolean> {
    return this.viewModel.isFirstOpendPage
  }

  get isNotMoreModelAnswerList(): ComputedRef<boolean> {
    return this.viewModel.isNotMoreModelAnswerList
  }

  setPageIndex(pageIndex: number): void {
    this.viewModel.setPageIndex(pageIndex)
  }

  setIsFirstOpendPage(flag: boolean): void {
    this.viewModel.setIsFirstOpendPage(flag)
  }

  reverseModelAnswerIsDiffFlag(judgeId: number): void {
    const currentFlag = this.viewModel.modelAnswerIsDiffList.value[judgeId]
    this.viewModel.setModelAnswerIsDiffFlag(judgeId, !currentFlag)
  }
}
